import axios from "axios";

export default {
  namespaced: true,
  state: {
    glreports: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    glreportsMessage: ''
  },
  mutations: {
    Do_Nothing(state) {
      state.isReceiving = false;
    },
    RECEIVED_GLREPORTS(state, payload) {
      state.glreports = payload;
      state.isReceiving = false;
    },
    RECEIVING_GLREPORTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_GLREPORT(state, payload) {
      state = Object.assign(state, {
        glreports: [...state.glreports, payload],
        isReceiving: false,
      })
    },
    RECEIVING_GLREPORT(state) {
      state.isReceiving = true;
    },
    UPDATED_GLREPORT(state, payload) {
      let index = state.glreports.findIndex(glreport => glreport._id === payload._id);
      state = Object.assign(state, {
        glreports: state.glreports.map((glreport, i) => {
          if (i === index) {
            return Object.assign({}, glreport, payload);
          }
          return glreport;
        }),
        isUpdating: false,
        glreportsMessage: 'GLReports has been updating!',
      })
    },
    UPDATING_GLREPORT(state) {
      state.isUpdating = true;
    },
    DELETED_GLREPORT(state, payload) {
      let indexToDelete = state.glreports.findIndex(glreport => glreport._id === payload._id);
      let glreports = [...state.glreports];
      glreports.splice(indexToDelete, 1);
      state = Object.assign(state, {
        glreports: [...glreports],
        isDeleting: false,
        idToDelete: null,
        glreportsMessage: 'GLReport has been Deleted!',
      });
    },
    DELETING_GLREPORT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getGLReportISRequest({dispatch}) {
      dispatch("doNothing");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/gl-report/is';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "GET", url: url, headers: headers});
      return response.data;
    },
    async getGLReportBSRequest({dispatch}) {
      dispatch("doNothing");
      let token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.accountxc.com:3100/get/gl-report/bs';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "GET", url: url, headers: headers});
      return response.data;
    },
    async getGLReportGLRequest({dispatch}) {
      dispatch("doNothing");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/gl-report/gl';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "GET", url: url, headers: headers});
      return response.data;
    },
    async findGLReportISRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/gl-report/is';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findGLReportGLRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/gl-report/gl';
        console.log(payload)
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findGLReportBSRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/gl-report/bs';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertGLReportRequest({dispatch}, payload) {
      dispatch("receivingGLReports");
      let token = localStorage.getItem('token');
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let url = 'https://api.accountxc.com:3100/insert/gl-report';
      let data = payload;
      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveGLReport", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    deleteGLReportRequest({dispatch}, payload) {
      dispatch("deletingGLReport", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/gl-report/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteGLReport", {_id: payload._id});
      })
    },
    doNothing({commit}) {
      commit("Do_Nothing")
    },
    receiveGLReports({commit}, payload) {
      commit("RECEIVED_GLREPORTS", payload)
    },
    receivingGLReports({commit}) {
      commit("RECEIVING_GLREPORTS")
    },
    receiveGLReport({commit}, payload) {
      commit("RECEIVED_GLREPORT", payload)
    },
    receivingGLReport({commit}) {
      commit("RECEIVING_GLREPORT")
    },
    updateGLReport({commit}, payload) {
      commit("UPDATED_GLREPORT", payload)
    },
    updatingGLReport({commit}) {
      commit("UPDATING_GLREPORT")
    },
    deleteGLReport({commit}, payload) {
      commit("DELETED_GLREPORT", payload)
    },
    deletingGLReport({commit}, payload) {
      commit("DELETING_GLREPORT", payload)
    }
  },
};
